import React from 'react';
import Attributes from '../../../components/Attributes';
import Button from '../../../components/Button';
import useModal from '../../../hooks/useModal';
import useAsync from '../../../hooks/useAsync';
import { getContacts } from '../../../api/contacts';
import SelectContacts from '../../../components/SelectContacts';
import { getUserFullName } from '../../../components/helpers/functions';
import { AvatarGenerated } from '../../../components/Avatar';
import { getTeam } from '../../../api/company';
import { TemplateReactSelect } from '../../../components/Attributes/Attributes_old';
import { getAllPowerUsers } from '../../../api/power-users';
import { PlusCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';

const getTitle = ({ type, title, company, location }) => {
	if (type === 'person') {
		if (company && title) {
			return `${title} at ${company.companyName}`;
		} else if (company && !title) {
			return `from ${company.companyName}`;
		} else if (!company && title) {
			return title;
		}
	} else if (type === 'company') {
		if (location) {
			return `${location && ` from ${location}`}`;
		}
		return null;
	}
	return null;
};
const ASSET_MODULE_ID = process.env.REACT_APP_MODULE_ID_ASSETS;

const PowerUsersStepAsset = ({
	moduleFieldsBreakdown,
	skipModuleKeys,
	updatedForm,
	setUpdateForm,
	form,
	setForm,
}) => {
	const { value: teammembers, execute: onRefreshUsers } = useAsync(getTeam);
	const { value: availablePowerusers } = useAsync(getAllPowerUsers);
	const { setOpen: openPowerUserModal } = useModal('addPowerUser');

	return (
		<>
			<div className="flex items-center justify-between w-full">
				<div className="flex-1">
					<TemplateReactSelect
						value=""
						blurInputOnSelect
						formatOptionLabel={({ label, type }) => (
							<div className="flex justify-between items-center cursor-pointer">
								<div>{label}</div>
								<div className="text-gray-400 text-xxs pl-3 truncate">
									{type === 'user' ? 'User' : 'Power User'}
								</div>
							</div>
						)}
						skip={updatedForm?.powerUsers?.map((o) => o?.id)}
						options={[
							{
								label: 'Active Users',
								options: teammembers?.rows?.length
									? teammembers?.rows?.map((member) => ({
											label: getUserFullName(member),
											value: member?.id,
											type: 'user',
									  }))
									: [],
							},
							{
								label: 'Power Users',
								options: availablePowerusers?.length
									? availablePowerusers?.map((member) => ({
											label: getUserFullName(member),
											value: member?.id,
											type: 'powermember',
									  }))
									: [],
							},
						]}
						onChange={(index, user, raw) => {
							const appendedUser =
								user?.type === 'powermember'
									? availablePowerusers?.find((o) => o.id === user?.value)
									: teammembers?.rows?.find((o) => o.id === user?.value);
							setUpdateForm({
								...updatedForm,
								powerUsers: [
									...(updatedForm?.powerUsers || []),
									{ ...appendedUser, type: user?.type },
								],
							});
						}}
					/>
				</div>
				<div>
					<PlusCircleIcon
						className="px-2 py-2 w-10 h-10 text-gray-700 cursor-pointer"
						onClick={() =>
							openPowerUserModal({
								onSubmit: (addedPowerUser) => {
									setUpdateForm({
										...updatedForm,
										powerUsers: [
											...(updatedForm?.powerUsers || []),
											{ ...addedPowerUser?.response, type: 'powermember' },
										],
									});
								},
							})
						}
					/>
				</div>
			</div>
			<ul role="list" className="space-y-2">
				{updatedForm?.powerUsers?.map((person) => (
					<li
						key={person.email}
						className="flex justify-between gap-x-6 py-3 border-gray-200 border-l-8 pl-6 border"
					>
						<div className="flex min-w-0 gap-x-2 cursor-pointer w-full">
							<AvatarGenerated
								type={person.type}
								id={getUserFullName(person)}
								size="xs"
							/>
							<div className="min-w-0 flex-auto">
								<p className="text-sm/6 font-semibold text-gray-900">
									{person.companyName || getUserFullName(person)}{' '}
									<span className="text-gray-600 font-normal">
										{' '}
										{getTitle(person)}
									</span>
								</p>
								<p className="truncate text-xs/5 text-gray-500">
									{person.email}
								</p>
							</div>
						</div>
						<div className="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
							<p className="text-sm/6 text-gray-900">
								<XMarkIcon
									className="w-10 h-10 px-3 py-2 text-gray-600 mr-2 cursor-pointer"
									onClick={() => {
										setUpdateForm({
											...updatedForm,
											powerUsers: updatedForm?.powerUsers?.filter(
												(v) => v.id !== person.id
											),
										});
									}}
								/>
							</p>
						</div>
					</li>
				))}
			</ul>
		</>
	);
};

export default PowerUsersStepAsset;
